exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.event_header_container[data-v-1f6d313b]{position:fixed;top:0rem;left:0rem;width:100%;z-index:100;background-color:white;box-shadow:1px 1px 0.1rem #CCCCCC\n}\n", ""]);

// exports
